import { Col, Row } from 'antd';

import FormInput from '@/views/components/Inputs/FormInput';
import FormSelectBox from '@/views/components/Inputs/FormSelectBox';
import TrailerStoreIdSelector from '@/views/components/Selectors/TrailerStoreIdSelector';
import { STATUS_OPTIONS } from '@/views/pages/Savers/TrailerManagement/constants';
import { DEFAULT_PARAMS } from '@/views/pages/Savers/trailer-request.constants';

import { getTrailersListEffect } from '../../../../redux/Savers/SaversEffects';

const TrailerFilter = ({
  onTrailerLocationSearch,
  onSelectFilterByStatus,
  onSelectFilterByTrailerNumber,
  onSelectFilterBySupplyZone,
  onChangeGeneralSearch,
  searchLocationId,
  status,
  supplyZoneNumberOptions,
}) => {
  return (
    <Col flex={1}>
      <Row gutter={20}>
        <Col sm={5}>
          <TrailerStoreIdSelector
            label="Filter by Location"
            editMode
            name="sz2"
            margin="m-0"
            placeholder="Location #"
            onChange={onTrailerLocationSearch}
            params={searchLocationId ? `?branchKey=${searchLocationId}` : ''}
          />
        </Col>

        <Col sm={5}>
          <FormSelectBox
            label="Filter by Status"
            editMode
            name="trailer1"
            margin="m-0"
            placeholder="Status"
            defaultValue={status}
            options={STATUS_OPTIONS}
            onChange={onSelectFilterByStatus}
          />
        </Col>

        <Col sm={5}>
          <FormSelectBox
            label="Filter by Trailer #"
            editMode
            name="trailerNumber"
            margin="m-0"
            placeholder="Trailer #"
            asyncFetchMode
            onChange={onSelectFilterByTrailerNumber}
            asyncFunction={async (params) => {
              const requestParams = {
                trailerNumber: params.SearchValue,
              };
              const { data } = await getTrailersListEffect({ ...DEFAULT_PARAMS, ...requestParams });
              const options = data.map((row) => ({
                label: row.trailerNumber,
                value: row.trailerID,
              }));
              return { data: options };
            }}
            searchParamName="SearchValue"
            searchParamMinLength={3}
          />
        </Col>

        <Col sm={5}>
          <TrailerStoreIdSelector
            label="Filter by Supply Zone"
            editMode
            name="SzNumber"
            placeholder="SupplyZone Number"
            isIDSelector={false}
            onChange={onSelectFilterBySupplyZone}
            options={supplyZoneNumberOptions}
          />
        </Col>

        <Col sm={4}>
          <FormInput
            name="GeneralSearch"
            label="General Search"
            margin="m-0"
            editMode
            onChange={onChangeGeneralSearch}
          />
        </Col>
      </Row>
    </Col>
  );
};

export default TrailerFilter;
